// extracted by mini-css-extract-plugin
module.exports = {"button":"MoreButtonDropdown_button__2U7KG","dropdown":"MoreButtonDropdown_dropdown__3JcDq"};